import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import Loader from "./components/ui/Loader";
import TesterHubPage from "./pages/TesterHubPage";
import TesterAppsPage from "./pages/TesterAppsPage";

const UploadPage = lazy(() => import("./pages/UploadPage"));
const ProfilePage = lazy(() => import("./pages/ProfilePage"));
const DashboardPage = lazy(() => import("./pages/DashboardPage"));
const NotFound = lazy(()=> import("./pages/NotFound"));
const EditGamePage = lazy(()=> import("./pages/EditGamePage"));
const ProtectedRoute = lazy(() => import("./components/ProtectedRoute"));
const DevlogReels = lazy(() => import("./pages/DevlogReels"));
const DevlogDetailsPage = lazy(() => import("./pages/DevlogDetailsPage"));
const ContactPage = lazy(() => import("./pages/ContactPage"));
const PrivacyPolicyPage = lazy(() => import("./pages/PrivacyPolicyPage"));
const AboutUsPage = lazy(() => import("./pages/AboutUsPage"));
const Index = lazy(() => import("./pages/Index"));
const GamePage = lazy(() => import("./pages/GamePage"));
const PopularGamesPage = lazy(() => import("./pages/PopularGamesPage"));
const RecommendedGamesPage = lazy(() => import("./pages/RecommendedGamesPage"));
const SpecialMentionsPage = lazy(() => import("./pages/SpecialMentionsPage"));
const ForgotPasswordPage = lazy(() => import("./pages/ForgotPasswordPage"));
const ResetPasswordPage = lazy(() => import("./pages/ResetPasswordPage"));
const LinkedInCallbackPage = lazy(() => import("./pages/LinkedInCallbackPage"));
const GitHubCallbackPage = lazy(() => import("./pages/GitHubCallBackPage"));
const TesterSubmissionPage = lazy(() => import("./pages/TesterSubmissionPage"));
const LeaderboardsPage = lazy(() => import("./pages/LeaderboardsPage"));
const App = () => (
	<Suspense fallback={<Loader label="Loading games" />}>
		<Routes>
			<Route path="/" element={<Index />} />
			<Route path="/tester-hub" element={<TesterHubPage />} />
			<Route path="/tester-hub/apps" element={<TesterAppsPage />} />
			<Route path="/tester-hub/:id" element={<TesterSubmissionPage />} />
			<Route path="/popular" element={<PopularGamesPage />} />
			<Route path="/recommended" element={<RecommendedGamesPage />} />
			<Route path="/special-mentions" element={<SpecialMentionsPage />} />
			<Route path="/leaderboards" element={<LeaderboardsPage />} />
			<Route path="/game/:slug" element={<GamePage />} />
			<Route path="/games/:slug" element={<GamePage />} />
			<Route path="/devlog" element={<DevlogReels />} />
			<Route path="/devlogs/:slug" element={<DevlogDetailsPage />} />
			<Route path="/contact" element={<ContactPage />} />
			<Route path="/privacy" element={<PrivacyPolicyPage />} />
			<Route path="/about" element={<AboutUsPage />} />
			<Route path="/forgot-password" element={<ForgotPasswordPage />} />
			<Route path="/reset-password" element={<ResetPasswordPage />} />
			<Route path="/github/callback" element={<GitHubCallbackPage />} />
			<Route path="/linkedin/callback" element={<LinkedInCallbackPage />} />
			<Route
				path="/game/:id/edit"
				element={
					<ProtectedRoute>
						<EditGamePage />
					</ProtectedRoute>
				}
			/>
			<Route path="/upload" element={<UploadPage />} />
			<Route
				path="/profile"
				element={
					<ProtectedRoute>
						<ProfilePage />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/dashboard"
				element={
					<ProtectedRoute>
						<DashboardPage />
					</ProtectedRoute>
				}
			/>
			<Route path="*" element={<NotFound />} />
		</Routes>
	</Suspense>
);

export default App;
